// ----------------
// Gallery Page Module
// ----------------
// Calling this module will set up a Loader instance and functions
// for the blog page only.
// ---------------------------------------------------------------
import finishesController from './finishes'

function check() {
    return !!document.getElementById('page-finishes-listing')
}

function init() {
    if (!check()) return
    finishesController()
}

export default init
